// extracted by mini-css-extract-plugin
export default {"userBox":"UserBox_userBox__kqnuN","boxText":"UserBox_boxText__4zTsi"};